import {CriteriaType, FilterCriteria} from "@/model/filter-criteria";

export class TransactionFilter {
  _dateFrom = '';
  _dateTo = '';
  dateRange = [];
  countryCodeTo = 'XX';
  okPaymentState = false;
  msisdn = '';
  email = '';
  paymentId = '';
  paypalPayerId = '';
  creditCardTokenFilter = '';
  userId = '';
  phoneNumber = '';
  ipAddressFrom = '';
  payerInfoEmail = '';

  static fromCriteria(c: FilterCriteria) {
    if(c.type === CriteriaType.MSISDN) {
      return new TransactionFilter().withMsisdn(c.value);
    }
    if(c.type === CriteriaType.USER_ID) {
      return new TransactionFilter().withUserId(c.value);
    }
    if(c.type === CriteriaType.EMAIL) {
      return new TransactionFilter().withEmail(c.value);
    }
    return new TransactionFilter();
  }

  get dateFrom() {
    return this._dateFrom? this._dateFrom : this.dateRange[0]
  }

  get dateTo() {
    return this._dateTo? this._dateTo : this.dateRange[1]
  }

  withMsisdn(s: string) {
    this.msisdn = s
    return this
  }

  withUserId(s: string) {
    this.userId = s
    return this
  }

  withEmail(s: string) {
    this.email = s
    return this
  }
}
